// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_i3-0";
export var fileCarousel = "_i3-2";
export var removeFileButton = "_i3-1";